import { Gamepad2, ArrowRight, Music2, Brain } from 'lucide-react';

export default function RejoindrePartie() {
  return (
    <div className="max-w-lg mx-auto px-4 py-16 text-center fade-in" data-testid="rejoindre-page">
      {/* Header */}
      <div className="mb-10">
        <div className="w-16 h-16 rounded-2xl mx-auto mb-4 flex items-center justify-center" style={{ background: 'linear-gradient(135deg, rgba(220,38,38,0.15), rgba(59,130,246,0.15))' }}>
          <Gamepad2 className="w-8 h-8" style={{ color: '#DC2626' }} />
        </div>
        <h1 className="text-3xl sm:text-4xl font-black tracking-tight mb-2" style={{ fontFamily: 'Outfit', background: 'linear-gradient(135deg, #fff, #DC2626, #3B82F6)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
          Rejoindre une partie
        </h1>
        <p className="text-[#A1A1AA]">Choisis ton jeu pour commencer</p>
      </div>

      <div className="grid gap-5" data-testid="game-choice">
        {/* Quizz — Kahoot */}
        <a href="https://kahoot.it/" target="_blank" rel="noopener noreferrer" data-testid="quizz-btn"
          className="block bg-[#121212] border border-white/5 rounded-3xl p-8 text-left apple-press transition-transform hover:scale-[1.02]"
          style={{ boxShadow: '0 0 40px rgba(139,92,246,0.06)' }}>
          <div className="flex items-center gap-4">
            <div className="w-14 h-14 rounded-2xl flex items-center justify-center shrink-0" style={{ background: 'linear-gradient(135deg, rgba(139,92,246,0.2), rgba(59,130,246,0.15))' }}>
              <Brain className="w-7 h-7" style={{ color: '#8B5CF6' }} />
            </div>
            <div className="flex-1">
              <h2 className="text-xl font-black" style={{ fontFamily: 'Outfit' }}>Quizz</h2>
              <p className="text-sm text-[#A1A1AA]">Réponds aux questions sur Kahoot!</p>
            </div>
            <ArrowRight className="w-5 h-5 text-[#8B5CF6]" />
          </div>
        </a>

        {/* Blind Test — Vibzz */}
        <a href="https://vibzz.app/join" target="_blank" rel="noopener noreferrer" data-testid="blindtest-btn"
          className="block bg-[#121212] border border-white/5 rounded-3xl p-8 text-left apple-press transition-transform hover:scale-[1.02]"
          style={{ boxShadow: '0 0 40px rgba(220,38,38,0.06)' }}>
          <div className="flex items-center gap-4">
            <div className="w-14 h-14 rounded-2xl flex items-center justify-center shrink-0" style={{ background: 'linear-gradient(135deg, rgba(220,38,38,0.2), rgba(59,130,246,0.15))' }}>
              <Music2 className="w-7 h-7" style={{ color: '#DC2626' }} />
            </div>
            <div className="flex-1">
              <h2 className="text-xl font-black" style={{ fontFamily: 'Outfit' }}>Blind Test</h2>
              <p className="text-sm text-[#A1A1AA]">Devine les musiques sur Vibzz</p>
            </div>
            <ArrowRight className="w-5 h-5 text-[#DC2626]" />
          </div>
        </a>
      </div>

      {/* Info */}
      <div className="mt-10 space-y-4 text-left">
        <h3 className="text-sm font-semibold text-[#D4AF37]" style={{ fontFamily: 'Outfit' }}>{"Comment ça marche ?"}</h3>
        <div className="grid gap-3">
          {[
            { n: "1", t: "L'animateur lance une partie", d: "Les infos s'affichent sur l'écran de la salle" },
            { n: "2", t: "Choisis ton jeu : Quizz ou Blind Test", d: "Quizz sur Kahoot, Blind Test sur Vibzz" },
            { n: "3", t: "Joue et réponds en direct !", d: "Sur ton téléphone, en temps réel" },
          ].map(s => (
            <div key={s.n} className="flex items-start gap-3 bg-[#121212] border border-white/5 rounded-xl p-3">
              <div className="w-7 h-7 rounded-lg flex items-center justify-center shrink-0 text-xs font-black" style={{ background: 'linear-gradient(135deg, rgba(220,38,38,0.15), rgba(59,130,246,0.15))', color: '#DC2626' }}>{s.n}</div>
              <div><p className="text-sm font-semibold">{s.t}</p><p className="text-[10px] text-[#A1A1AA]">{s.d}</p></div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
